import "./Allcities.css";
const Allcities = () => {
    return (
        <>
        <div className="cities">
            <h4>A</h4>
            <h4>B</h4>
           <h4>C</h4>
           <h4>D</h4>
           <h4>E</h4>
           <h4>F</h4>
           <h4>G</h4>
           <h4>H</h4>
           <h4>I</h4>
           <h4>J</h4>
           <h4>K</h4>
           <h4>L</h4>
           <h4>M</h4>
           <h4>N</h4>
           <h4>O</h4>
           <h4>P</h4>
           <h4>Q</h4>
           <h4>R</h4>
           <h4>S</h4>
           <h4>T</h4>
           <h4>U</h4>
           <h4>V</h4>
           <h4>W</h4>
           
           <h4>X</h4>
           <h4>Y</h4>
           <h4>Z</h4>
        </div>
      <div className="city_outer_div">
      
        <div className="city_inner_div">
            <p>Agartala</p>
            <p>Ajmer</p>
            <p>Aligarh</p>
            <p>Ambaji</p>
            <p>Amritsar</p>
            <p>Ankleshwar</p>
            <p>Aurangabad</p>
            <p>Baddi</p>
            <p>Banaswara</p>

            <p>Baramati</p>
            <p>Bathinda</p>
            <p>Behror</p>
            <p>Bharatpur</p>
            <p>Bhiwadi</p>
        </div>
        <div className="city_inner_div">
            
        <p>Agra</p>
          <p>Agra</p>
          <p>Akola</p>
          <p>Alipurduar</p>
          <p>Ambajogai</p>
          <p>Anand</p>
          <p>Arakkonam</p>
          <p>Bahadurgarh</p>
          <p>Banda</p>
          <p>Bareilly</p>
          <p>Bawal</p>
          <p>Belgaum</p>
          <p>Bhavnagar</p>
          <p>Bhiwani</p>

        </div>
        <div className="city_inner_div">
      <p>Ahmedabad</p>

      <p>Alappuzha</p>
      <p>Almora</p>
      <p>Ambala</p>
      <p>Anantpur</p>
      <p>Arrah</p>
      <p>Auoville</p>
      <p>Balasore</p>
      <p>Banglore</p>
      <p>Bargarh</p>
      <p>Begusarai</p>
      <p>Berhampore</p>
      <p>Bhilai</p>
      <p>Bhopal</p>
        </div>
        <div className="city_inner_div">
        <p>Ahmednagar</p>
        <p>Alibagh</p>
        <p>Alwar</p>
        <p>Amrawati</p>
        <p>Angul</p> 
        <p>Asansol</p>
        <p>Ayodhya</p>
        <p>Banaskantha</p>
        <p>Bankura</p>
        <p>Barmer</p>
        <p>Behrampur</p>
        <p>Betul</p>
        <p>Bhilwara</p>
        <p>Bhubaneswar</p>
        </div>
      </div>
      </>
    );
  };
  export default Allcities;
  